import React, { useRef } from 'react';
import Slider from 'react-slick';
import { useTranslation } from 'react-i18next';

import img1 from "../../assets/homeSlider/step=1.png";
import img2 from "../../assets/homeSlider/step=2.png";
import img3 from "../../assets/homeSlider/step=3.png";
import img4 from "../../assets/homeSlider/step=4.png";
import img5 from "../../assets/homeSlider/step=5.png";

import sliderBg from "../../assets/homeSlider/Rectangle 1.png";
import sliderBg2 from "../../assets/homeSlider/Rectangle 2 (1).png";
import sliderBg3 from "../../assets/homeSlider/Rectangle 3.png";
import sliderBg4 from "../../assets/homeSlider/Rectangle 4.png";
import sliderBg5 from "../../assets/homeSlider/Rectangle 5.png";

import prev from "../../assets/Main/↳ Primary icon (1).png";
import nextIcon from "../../assets/Main/↳ Primary icon (2).png";

import './home-slider.css';
import MobileSlider from './mobileSlider';

function Carousel() {
  const { t } = useTranslation();
  let sliderRef1 = useRef(null);
  let sliderRef2 = useRef(null);

  const settings1 = {
    vertical: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
  };

  const settings2 = {
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    centerMode: true,
    centerPadding: '30px',
    responsive: [
      {
        breakpoint: 900,
        settings: {
          centerPadding: '20px',
        }
      },
      {
        breakpoint: 650,
        settings: {
          centerPadding: '10px',
        }
      }
    ]
  };

  const next = () => {
    sliderRef1.slickPrev();
    sliderRef2.slickPrev();
  };

  const previous = () => {
    sliderRef1.slickNext();
    sliderRef2.slickNext();
  };

  const slides = [
    { bg: sliderBg, title: t('homeSlider.title1'), desc: t('homeSlider.description1') },
    { bg: sliderBg2, title: t('homeSlider.title2'), desc: t('homeSlider.description2') },
    { bg: sliderBg3, title: t('homeSlider.title3'), desc: t('homeSlider.description3') },
    { bg: sliderBg4, title: t('homeSlider.title4'), desc: t('homeSlider.description4') },
    { bg: sliderBg5, title: t('homeSlider.title5'), desc: t('homeSlider.description5') }
  ];

  const steps = [img1, img2, img3, img4, img5];

  return (
    <>
      <div className="mainSlider overflow-hidden desktop-slider">
        <div className="position-relative">
          <div>
            <Slider ref={(slider) => (sliderRef1 = slider)} {...settings1}>
              {slides?.map((slide, index) => (
                <div key={index} className="position-relative bg-info-subtle">
                  <img className="w-50-me" src={slide.bg} alt="" />
                  <div className="desc text-center text-md-start w-50-me px-5 pb-5 mb-5 text-white position-absolute bottom-me">
                    <h1 className="BigshotOneFont">{slide.title}</h1>
                    <p className="hidden">{slide.desc}</p>
                  </div>
                </div>
              ))}
            </Slider>
          </div>

          <div className="position-absolute top-0 vh-100 d-flex align-items-center">
            <div className="navs position-absolute translate-middle start-50 bottom-0 mb-5 d-flex gap-4 z-3">
              <button
                onClick={previous}
                type="button"
                className="rounded-5 bg-dark bg-opacity-50 border-0 p-2"
              >
                <img className="w-100" src={prev} alt="prev" />
              </button>
              <button
                onClick={next}
                type="button"
                className="rounded-5 bg-dark bg-opacity-50 border-0 p-2"
              >
                <img className="w-100" src={nextIcon} alt="next" />
              </button>
            </div>

            <div className="mw-100 mh-100">
              <div className="vw-100">
                <Slider ref={(slider) => (sliderRef2 = slider)} {...settings2}>
                  {steps?.map((img, i) => (
                    <div key={i} className="sliderItem mt-5 pt-5">
                      <div className="item2 ms-auto sliderItemPadding">
                        <img
                          className="w-100 h-100 object-fit-fill"
                          src={img}
                          alt={`step-${i + 1}`}
                        />
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mobile-slider">
        <MobileSlider />
      </div>
    </>
  );
}

export default Carousel;
